import { OnInit, OnDestroy, Directive, inject } from "@angular/core";
import { Router } from "@angular/router";
import { SortMeta } from "primeng/api";
import { Subscription } from "rxjs";

import { CrudAbstractModel } from "./crud-abstract.model";
import { CrudAbstractRepository } from "./crud-abstract.repository";
import { User } from "../user/user.model";
import { PaginationList } from "../shared/grid/pagination-list.model";
import { GridParams } from "../shared/grid/grid-params";
import { GridSortingService } from "../shared/grid/grid-sorting.service";
import { ORDER } from "../shared/grid/order.enum";

@Directive()
export abstract class CrudAbstractListComponent implements OnInit, OnDestroy {
  public gridParams: GridParams = inject(GridParams);
  protected sortingService: GridSortingService = inject(GridSortingService);
  protected router: Router = inject(Router);
  protected repository: CrudAbstractRepository;

  public user: User = null;
  public loading = true;
  public items: PaginationList<any> = new PaginationList<any>();
  public searchQuery = "";
  protected subscription = new Subscription();
  protected fetchSubscription?: Subscription;

  ngOnInit() {
    this.loadParams();
    this.fetchList();
    this.subscribeToEvents();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public subscribeToEvents() {
    this.subscription.add(
      this.gridParams.onChange.subscribe(() => this.fetchList()),
    );
  }

  public loadPage(
    page: number,
    rows: number = this.gridParams.getParam("limit"),
  ) {
    this.gridParams.setParams({
      page: page,
      limit: rows,
    });
  }

  public sortGrid({ field, order }: SortMeta) {
    this.sortingService.sortGrid(field, ORDER[order]);
  }

  public onSearchQueryChange() {
    this.gridParams.setParams({
      search: this.searchQuery,
      page: 1,
    });
  }

  public addNewItem(): void {
    this.router.navigate([this.repository.getEndpoint() + "/0"]);
  }

  public openItem(model: CrudAbstractModel): void {
    this.router.navigate([this.repository.getEndpoint() + "/" + model.getId()]);
  }

  public fetchList(): void {
    this.fetchSubscription?.unsubscribe();

    const requestParams = this.gridParams.getHttpParams();
    this.loading = true;
    this.fetchSubscription = this.repository
      .paginatedList(requestParams)
      .subscribe((items) => {
        this.items = items;
        this.loading = false;
      });
    this.subscription.add(this.fetchSubscription);
  }

  public loadParams() {
    this.searchQuery = this.gridParams.getParam("search");
  }
}
